import { Button, Dialog, DropdownList, DropdownListItem, Typography } from '@nexans/react-ui-kit'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@/config/api'
import { useAppStore } from '@/stores'
import { AvailableCountry } from '@/types/openapi-public'

type ForceCountryDialogProps = {
  opened: boolean
  onClose: () => void
}

const ForceCountryDialog = ({ opened, onClose }: ForceCountryDialogProps) => {
  const { t } = useTranslation(['common', 'enums'])
  const forceCountry = useAppStore((state) => state.forceCountry)
  const setForceCountry = useAppStore((state) => state.actions.setForceCountry)
  const queryClient = useQueryClient()
  const [value, setValue] = useState<AvailableCountry | ''>(forceCountry ?? '')

  const handleClose = () => {
    setValue(forceCountry ?? '')
    onClose()
  }

  const handleForceCountry = () => {
    setForceCountry(value === '' ? undefined : value)
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.getServices] })
    onClose()
  }

  const options = Object.values(AvailableCountry).map((c) => ({
    label: t(`enums:enum.available_country.${c}`),
    value: c,
  }))

  return (
    <Dialog opened={opened} title={t('common:labels.force_country_title')} closable onClose={handleClose}>
      <Dialog.Body>
        <DropdownList
          keyValue="value"
          options={options}
          renderItem={(item) => <DropdownListItem value={item.value}>{item.label}</DropdownListItem>}
          renderLabel={(item) => (
            <Typography color="textPrimary" variant="body2">
              {item[0]?.label ?? ''}
            </Typography>
          )}
          value={value}
          onSelectedChange={(selected) => {
            setValue(selected[0]?.value ?? '')
          }}
        />
      </Dialog.Body>
      <Dialog.Actions>
        <Button variant="outlined" onClick={handleClose}>
          {t('common:actions.cancel')}
        </Button>
        <Button color="destructive" onClick={handleForceCountry}>
          {t('common:actions.validate')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  )
}

export default ForceCountryDialog
